import React, { useContext } from 'react';
import { darkModeContext } from '../../darkModeContext';
/** @jsx jsx */
import { css, jsx } from '@emotion/core';
import { TagIcon } from '@tag/tag-components-react-v3';

export const DarkModeToggle = () => {
  const docsDarkMode = useContext(darkModeContext);
  const docsDarkModeValue = docsDarkMode.value || false;

  const handleToggleChange = (e: any) => {
    if (docsDarkMode && docsDarkMode.setValue) {
      docsDarkMode.setValue(e.target.checked);
    }
  };

  return (
    <div
      css={css`      
        display: block;
        align-self: center;
        justify-content: center;
        margin-top: 5px;
        }
      `}
    >
      <label className="switch">
        <input
          className="sliderInput"
          type="checkbox"
          onChange={handleToggleChange}
          checked={docsDarkModeValue}
        />
        <span className="slider round">
          <div
            css={css`
              display: flex;
              justify-content: space-between;
              align-items: center;
              height: 100%;
            `}
          >
            <TagIcon icon={'Moon'} accent="white" />
            <TagIcon icon={'WeatherSun'} accent="sunflower" />
          </div>
        </span>
      </label>
    </div>
  );
};
